import { RightOutlined } from '@ant-design/icons';
import { IssueCaseDoc, IssueTaskDoc } from '@gooduncles/gu-app-schema';
import { FC, useState } from 'react';

import { getIssueCaseLabel, isIssueTaskEditable } from 'src/utils/issue/issue-util';

import styles from './IssueTaskGroup.module.scss';

import IssueTaskCard from '../IssueTaskCard';

interface IssueTaskGroupProps {
  issueCase: IssueCaseDoc;
  tasks: IssueTaskDoc[];
}

const IssueTaskGroup: FC<IssueTaskGroupProps> = ({ issueCase, tasks }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div
      className={styles.taskGroup}
      style={{ flex: isCollapsed ? 0 : 1, paddingBottom: isCollapsed ? 8 : undefined }}
      key={issueCase._id}
      id={`task-group-${issueCase._id}`}>
      <div className={styles.taskGroupHeader} onClick={() => setIsCollapsed(!isCollapsed)}>
        <RightOutlined
          style={{
            transform: isCollapsed ? 'rotate(0deg)' : 'rotate(90deg)',
            transition: 'transform 0.2s ease-in-out',
          }}
        />
        {getIssueCaseLabel(issueCase)}
      </div>
      <div className={styles.taskGroupContent} style={{ display: isCollapsed ? 'none' : 'flex' }}>
        {tasks.map((task) => (
          <IssueTaskCard
            key={task._id}
            issueTaskDoc={task}
            issueTaskDocs={tasks}
            issueCaseDoc={issueCase}
            editable={isIssueTaskEditable(task)}
          />
        ))}
      </div>
    </div>
  );
};

export default IssueTaskGroup;
export type { IssueTaskGroupProps };
